import { TablistStyles, TablistTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { Tablist } from "./tablist.js";
/**
 * The Fabric Tablist component.
 *
 * @public
 */
export const definition = Tablist.compose({
    name: `${DesignSystem.prefix}-tablist`,
    template: TablistTemplate,
    styles: TablistStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=tablist.definition.js.map